const Footer = () => (
  <div>
    <footer className="footer">
      <p>
        Created by
        <a href="./">CobbyElsonfx</a>
      </p>
    </footer>
  </div>
);

export default Footer;
